import React from 'react';

export const CheckmarkCircle: React.FC<{color: string}> = ({color}) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
    <circle cx="40" cy="40" r="39.25" stroke={color} strokeWidth="1.5" />
    <path d="M29.5218 39.3501L36.4739 46.3022L50.3782 32.3979" stroke={color} strokeWidth="1.5" />
  </svg>
);
